import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useVerifySso } from "../useQuery";

const SSOCallback = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("sessionId");
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const { mutate: verifySso } = useVerifySso({
    onSuccess: (data) => {
      const payload = data?.ssoStatus ? data.ssoStatus : data;

      try {
        const company = payload?.company;
        if (company) {
          const derivedEmail = payload?.username || payload?.ssoUserInfo?.email;
          const userDetailToStore = {
            ...payload,
            email: derivedEmail,
            companyid: company?.idcompany,
            usertype: payload?.usertype,
            token: payload?.randomkey,
            isSsoLogin: true,
          };

          localStorage.setItem(
            "userDetail",
            JSON.stringify(userDetailToStore),
          );

          localStorage.setItem(
            "colorcode",
            JSON.stringify({
              primaryColor: company?.primaryColor,
              secondaryColor: company?.secondaryColor,
              tertiaryColor: company?.tertiaryColor,
              brandLogo: company?.brandLogo,
              companyurl: company?.companyurl,
            }),
          );
          localStorage.setItem("isSsoLogin", "true");
          
          navigate("/new");
        } else {
          setError("Company information not found. Please contact support.");
          setTimeout(() => navigate("/login"), 3000);
        }
      } catch (e) {
       
        setError("An error occurred during sign-in. Redirecting to login...");
        setTimeout(() => navigate("/login"), 3000);
      }
    },
    onError: (error) => {
    
      setError(
        error?.message || "Authentication failed. Please try again."
      );
      setTimeout(() => navigate("/login"), 3000);
    },
  });

  useEffect(() => {
    if (sessionId) {
      verifySso({ sessionId });
    } else {
      setError("Invalid callback: Missing session ID.");
      setTimeout(() => navigate("/login"), 3000);
    }
  }, [sessionId, verifySso, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <div className="mb-4 text-red-600">
              <svg
                className="mx-auto h-12 w-12"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <h3 className="mb-2 text-xl font-semibold">Sign-in Failed</h3>
            <p className="text-gray-600">{error}</p>
            <p className="mt-4 text-sm text-gray-500">
              Redirecting to login page...
            </p>
          </>
        ) : (
          <>
            <div className="mb-4">
              <div className="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600"></div>
            </div>
            <h3 className="text-xl font-semibold">Completing sign-in…</h3>
            <p className="mt-2 text-gray-600">Please wait...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default SSOCallback;